import React from 'react';
import { Input } from '@/Components/ui/input';
import { Label } from '@/Components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/Components/ui/select';
import { MapPin, Phone, Mail } from 'lucide-react';
import { getColor } from '@/lib/theme-utils';

function LocationForm({ countryCode, setCountryCode, phoneNumber, setPhoneNumber, email, setEmail, mapLocation, setMapLocation }) {
  const countries = [
    { code: '+91', name: 'India' },
    { code: '+1', name: 'United States' },
    { code: '+44', name: 'United Kingdom' },
    { code: '+971', name: 'UAE' },
    { code: '+65', name: 'Singapore' },
    { code: '+61', name: 'Australia' },
    { code: '+49', name: 'Germany' },
    { code: '+33', name: 'France' },
    { code: '+81', name: 'Japan' },
    { code: '+86', name: 'China' },
    { code: '+880', name: 'Bangladesh' },
    { code: '+94', name: 'Sri Lanka' },
    { code: '+977', name: 'Nepal' },
  ];

  return (
    <form className="flex flex-col gap-4 md:gap-5 w-full">
      {/* Map Location */}
      <div className="flex flex-col gap-2">
        <Label htmlFor="map-location" className="text-sm font-semibold">
          Map Location
        </Label>
        <div className="relative group/map">
          <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within/map:text-primary" />
          <Input
            id="map-location"
            type="text"
            value={mapLocation}
            onChange={(e) => setMapLocation(e.target.value)}
            placeholder="Enter map location..."
            className="!pl-10 !pr-3 !h-10 !py-2 transition-all"
          />
        </div>
      </div>

      {/* Phone Input - Side by side layout */}
      <div className="grid grid-cols-1 md:grid-cols-[140px_1fr] gap-4 md:gap-5">
        <div className="flex flex-col gap-2">
          <Label htmlFor="country-code" className="text-sm font-semibold">
            Country Code
          </Label>
          <Select value={countryCode} onValueChange={setCountryCode}>
            <SelectTrigger id="country-code" className="h-10">
              <SelectValue placeholder="Select..." />
            </SelectTrigger>
            <SelectContent>
              {countries.map((country) => (
                <SelectItem key={country.code} value={country.code}>
                  {country.code} {country.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="flex flex-col gap-2">
          <Label htmlFor="phone-number" className="text-sm font-semibold">
            Phone Number
          </Label>
          <div className="relative group/phone">
            <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within/phone:text-primary" />
            <Input
              id="phone-number"
              type="tel"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Enter phone number"
              className="!pl-10 !pr-3 !h-10 !py-2 transition-all"
            />
          </div>
        </div>
      </div>

      {/* Email Input */}
      <div className="flex flex-col gap-2">
        <Label htmlFor="email-address" className="text-sm font-semibold">
          Email
        </Label>
        <div className="relative group/email">
          <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none z-10 transition-colors group-focus-within/email:text-primary" />
          <Input
            id="email-address"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter email address"
            className="!pl-10 !pr-3 !h-10 !py-2 transition-all"
          />
        </div>
      </div>
    </form>
  );
}

export default LocationForm;